import axios from "../api";
export const getGallerySet = async (categorySlug, setSlug) => {
    const res = await axios.get(`/gallery/sets/${categorySlug}/${setSlug}`);
    return res.data;
};
//# sourceMappingURL=getGallerySet.js.map